import { plumbingRepair } from "./Plumbing/repair";
import { electricalRepair } from "./Electrical/repair";
import { heatingCoolingRepair } from "./HeatingCooling/repair";
import { heatingCoolingInstallation } from "./HeatingCooling/Installation";
import { HeatingCoolingMaintenance } from "./HeatingCooling/maintenance";
import { electricalInstallation } from "./Electrical/Installation";
import { ElectricalMaintenance } from "./Electrical/maintenance";
import { plumbingInstallation } from "./Plumbing/Installation";
import { PlumbingMaintenance } from "./Plumbing/maintenance";
import { DrainsSewer } from "./Plumbing/drainsSewer";
import { IndoorAirQuality } from "./HeatingCooling/IndoorAirQuality";
import { gasAndGasLines } from "./Plumbing/gasAndGasLines";
import { waterLeak } from "./Plumbing/waterLeak";
import { generators } from "./Electrical/generators"
import { solar } from "./Electrical/solar"
import * as Icons from "../components/Icons/jobIcons";
import { Electrical } from "../components/Icons";

export function serviceTypeList() {
  let servicesStart = {
    Plumbing: [],
    "Heating & Cooling": [],
    Electrical: []
  };
 let heatingAndCoolingArray = [
  {
    id: "Repair",
    label: <>Repair</>,
    icon: Icons?.HvacRepair,

    data: heatingCoolingRepair(),
  },

  {
    id: "Estimate",
    label: <>Installation</>,
    icon: Icons?.HvacInstallation,

    data: heatingCoolingInstallation(),
  },
  {
    id: "Maintenance",
    label: <>Maintenance</>,
    icon: Icons?.Maintenance,
    data: HeatingCoolingMaintenance(),
  },
  {
    id: "Indoor Air Quality",
    label: <>Indoor Air Quality</>,
    icon: Icons?.AirQuality,
    data: IndoorAirQuality(),
  },
]
 let PlumbingArray = [
  {
    id: "Water Leak",
    label: <>Water Leak</>,
    icon: Icons?.WaterLeakRepair,
    data: waterLeak()
  },
  {
    id: "Drains & Sewer",
    label: <>Drains & Sewer</>,
    icon: Icons?.DrainsSewer,
    data: DrainsSewer(),
  },
  {
    id: "Repair",
    label: <>Repair</>,
    data: plumbingRepair(),
    icon: Icons?.PlumbingRepair,
  },
  {
    id: "Estimate",
    label: <>Installation</>,
    icon: Icons?.PlumbingInstallation,
    data: plumbingInstallation(),
  },

  {
    id: "Gas & Gas Lines",
    label: <>Gas & Gas Lines</>,
    icon: Icons?.GasLine,

    data: gasAndGasLines()
  },
  {
    id: "Maintenance",
    label: <>Maintenance</>,
    icon: Icons?.Maintenance,

    data: PlumbingMaintenance(),
  },
]

 let ElectricalArray =[ {
    id: "Repair",
    label: <>Repair</>,
    icon: Icons?.ElectricalRepair,
    data: electricalRepair(),
  },
  {
    id: "Generators",
    label: <>Generators</>,
    icon: Icons?.Generator,
    data: generators()
  },
  {
    id: "Maintenance",
    label: <>Maintenance</>,
    data: ElectricalMaintenance(),
    icon: Icons?.Maintenance,
  },
  {
    id: "Solar",
    label: <>Solar</>,
    icon: Icons?.Solar,
    data: solar()
  },
  {
    id: "Estimate",
    label: <>Installation</>,
    icon: Icons?.ElectricalInstallation,

    data: electricalInstallation(),
  }
 ]
 heatingAndCoolingArray.map(services =>{
  addServicesIfExist(services.data, services,"Heating & Cooling")
 })
 ElectricalArray.map(services =>{
  addServicesIfExist(services.data, services,"Electrical")
 })
 PlumbingArray.map(services =>{
  addServicesIfExist(services.data, services,"Plumbing")
 })

  function addServicesIfExist(serviceFunction, serviceObject, serviceEnd) {

    if (serviceFunction[0]) {
      servicesStart[serviceEnd].push(serviceObject)
    }
  }
  
  return servicesStart
}